<template>
<div class="ND_box">
    <img class="banner" :src="img" alt>
    <div class="contain">
        <div class="new-box">
            <div>
                <div class="title">{{list["title"]}}</div>
                <div class="date">
                    <div class="subtitle">发布时间：</div>
                    <div class="time">{{new Date(parseInt(list.addtime)).getFullYear() || ""}}-{{new Date(parseInt(list.addtime)).getMonth() + 1 || ""}}-{{new Date(parseInt(list.addtime)).getDay() + 1 || ""}}</div>
                </div>
                <div class="content">
                    <div v-html="list.content" class="pm"></div>
                </div>
            </div>
        </div>
        <div class="btn">
            <span @click="goPrev">上一篇</span>
            <span @click="goNext">下一篇</span>
            <router-link to="/NewsLists" tag="p" class="back">
                <i></i>返回
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
import api from '@/axios.js'
export default {
    data() {
        return {
            img: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/newsLists/banner.png",
            list: [/* {
                title: "南京步锐捷2019年年会顺利召开",
                addtime: "1559541604622",
                content: "内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容"
            } */]
        };
    },
    methods: {
        addViews(id) {
            api.addViews({
             newsId: id,
            }).then((response) => {
            });
        },
        goPrev() {
            let i = parseInt(this.$route.params.id) - 1;
            if (i < 0) return;
            this.list = this.newsList[i];
            this.$router.push({
                name: "NewsDetial",
                params: {
                    id: i
                }
            });
            this.addViews(this.list.id);
        },
        goNext() {
            let i = parseInt(this.$route.params.id) + 1;
            if (i >= this.newsList.length) return;
            this.list = this.newsList[i];
            this.$router.push({
                name: "NewsDetial",
                params: {
                    id: i
                }
            });
            this.addViews(this.list.id);
        }
    },
    mounted() {
        let i = this.$route.params.id;
        api.getNewsList({
          pageNum: 0,
          pageSize: 0
        }).then((response) => {
          this.newsList = response.data;
          this.list = response.data[i];
          this.addViews(this.list.id);
        });
        document.querySelector(".ND_box").parentNode.style.backgroundColor = "#f5f5f5";
    }
};
</script>

<style scoped>
.ND_box {
    background: #f5f5f5;
}

.contain {
    width: 85%;
    margin: 0 auto;
    font-size: 14px;
    color: #505050;
}

.banner {
    width: 100%;
}

.new-box {
    margin-top: 100px;
}

.date {
    width: 790px;
    margin-left: 50%;
    transform: translateX(-50%);
    border-bottom: 1px solid #d3d3d3;
}

.title {
    width: 790px;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 30px;
    display: inline-block;
    margin-bottom: 30px;
}

.back {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    background: #f9a310;
    color: #fff;
    font-size: 16px;
    float: right;
    margin: 40px 0 0 20px;
    display: flex;
    align-items: center;
}

.back>i {
    display: block;
    width: 32px;
    height: 32px;
    margin: 0 8px 0 10px;
    background: url("http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/newsLists/back.png") no-repeat 0 0;
}

.subtitle {
    width: 90px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    /* border: 1px solid #999;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px; */
    color: #949494;
    font-size: 16px;
    margin-bottom: 40px;
    display: inline-block;
}

.time {
    display: inline-block;
    font-size: 16px;
    color: #949494;
}

.content {
    margin-top: 32px;
    font-size: 16px;
    color: #999;
    line-height: 40px;
    background: #f5f5f5;
}

.pm {   
    display: inline-block; 
    width: 690px;
    margin-left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 35px 50px;
    margin-bottom: 10px;
}

.btn {
    text-align: center;
    margin-bottom: 50px;
}

.btn span {
    display: inline-block;
    width: 100px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    background: #f9a310;
    color: #fff;
    font-size: 16px;
    text-align: center;
    margin: 40px 0 0 20px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsDetial.vue